import styled from '@emotion/styled'
import theme from '../../../../styles/theme'
import { TextMediumMini400Style } from '../../../../styles/Text.styles'

export const HeaderSection = styled.div`
  flex: 0 0 auto;
`

export const ProjectTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const ProjectTag = styled.div`
  background-color: ${theme.colors.secondLight};
  border-radius: 1rem;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  ${TextMediumMini400Style};
  color: ${theme.colors.secondDark};
`
